import QuestionNumber from '../../QuizComponent/Questionnumber/Questionnumber'
import "../../QuizComponent/Questionsummary/Questionsummary.css"
import './ExamHistorySection.css';
import TestQuestionNumbers from './TestQuestionNumbers';

function ExamHistorySection({ attemptedQuestions, markForReviewQuestionsArray, testQuestions, viewedQuestionsArray, setSelectedQuestionNumber, selectedQuestionNumber, handleFinishTest, finishTest, totalQuestions, attemptedAndMarkedForReview, isCUET }) {
    return (
        <div className='d-flex flex-column' style={{ height: "100%" }}>
            <div className='container-fluid flex-shrink-0'>
                <div className="row text-center g-1 p-0">
                    {/* Not Visited */}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="status-card not-visited-card">
                            <div className="status-shape not-visited-shape">
                                <h6>{totalQuestions - viewedQuestionsArray?.length}</h6>
                            </div>
                            <p className="status-label">Not Visited</p>
                        </div>
                    </div>

                    {/* Not Answered */}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="status-card not-answered-card">
                            <div className="status-shape not-answered-shape">
                                <h6>{viewedQuestionsArray?.length - attemptedQuestions?.length - markForReviewQuestionsArray?.length}</h6>
                            </div>
                            <p className="status-label">Not Answered</p>
                        </div>
                    </div>

                    {/* Answered */}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="status-card answered-card">
                            <div className="status-shape answered-shape">
                                <h6>{attemptedQuestions?.length}</h6>
                            </div>
                            <p className="status-label answered-text">Answered</p>
                        </div>
                    </div>

                    {/* Marked for Review */}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="status-card marked-card">
                            <div className="status-shape marked-review-shape">
                                <h6>{markForReviewQuestionsArray?.length}</h6>
                            </div>
                            <p className="status-label marked-text">Marked for Review</p>
                        </div>
                    </div>

                    {/* Answered & Marked for Review */}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="status-card answered-marked-card">
                            <div className="status-shape answered-marked-shape">
                                <h6>{attemptedAndMarkedForReview?.length}</h6>
                            </div>
                            <p className="status-label marked-text">Answered & Marked for Review</p>
                        </div>
                    </div>
                </div>

            </div>
            <div className='flex-grow-1' style={{ overflow: "hidden" }}>
                <TestQuestionNumbers setSelectedQuestionNumber={setSelectedQuestionNumber} selectedQuestionNumber={selectedQuestionNumber} /* testQuestions={testQuestions} */ attemptedQuestions={attemptedQuestions} markForReviewQuestionsArray={markForReviewQuestionsArray} attemptedAndMarkedForReview={attemptedAndMarkedForReview} viewedQuestionsArray={viewedQuestionsArray} handleFinishTest={handleFinishTest} finishTest={finishTest} totalQuestions={totalQuestions} isCUET={isCUET} />
            </div>
        </div>
    )
}

export default ExamHistorySection
